import { render, staticRenderFns } from "./VtkAreaTabs.vue?vue&type=template&id=4ad1baa2&scoped=true"
import script from "./VtkAreaTabs.vue?vue&type=script&lang=js"
export * from "./VtkAreaTabs.vue?vue&type=script&lang=js"
import style0 from "./VtkAreaTabs.vue?vue&type=style&index=0&id=4ad1baa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1baa2",
  null
  
)

export default component.exports